export default {
    methods: {
        handlerFilter() {
            this.sellSeriesYears = []
            this.sellsSeries = []
            this.getData()
        },
        handlerCleanFilter() {
            this.sellSeriesYears = []
            this.sellsSeries = []
            this.client = {
                key: null,
                label: 'Selecciona una opción',
            }
            this.selectedYears = []
            this.topSellerSeries = []
            this.topSalesData = []
            this.topSellerOptions.labels = []
            this.details.forEach((item) => {
                item.value = 0
                item.series[0].data = []
            })
        },
        changeClient(e) {
            this.client = { key: e.key, label: e.label }
        },
        getParams(client, year) {
            const params = {
                page: 1,
                limit: 10000,
                order: {
                    _EntityId: 'desc',
                },
                filters: [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {},
                    },
                ],
            }
            if (year) {
                params.filters[0].Fields['date'] = {
                    type: 'date',
                    from: `${year}-01-01`,
                    to: `${year}-12-31`,
                }
            }
            if (client && client.key) {
                params.filters[0].Fields['client'] = {
                    type: 'number',
                    value: client.key,
                    lig: '=',
                }
            }
            return params
        },
        async getData() {
            this.isLoading = true
            this.isLoadingTopSells = true

            const params = this.getParams(this.client, this.selectedYears[0])
            const res = await this.$gestios.items('bills').list(params)
            if (res.ok) {
                // // total Invert
                // this.details[0].value = res.data.reduce((acc, cvv) => acc + cvv.subtotal, 0)
                // this.details[0].series = [
                //     { ...this.details[0].series[0], data: res.data.flatMap((item) => item.subtotal) },
                // ]

                // total Profit
                this.details[0].value = res.data.reduce((acc, cvv) => acc + cvv.total + cvv.surcharge, 0)
                this.details[0].series = [
                    { ...this.details[0].series[0], data: res.data.map((item) => item.total + item.surcharge) },
                ]

                // // total Spent
                // this.details[2].value = res.data.reduce((acc, cvv) => acc + cvv.surcharge, 0)
                // this.details[2].series = [
                //     { ...this.details[2].series[0], data: res.data.flatMap((item) => item.surcharge) },
                // ]

                // IVA
                this.details[1].value = res.data.reduce((acc, cvv) => acc + cvv.iva, 0)
                this.details[1].series = [{ ...this.details[1].series[0], data: res.data.flatMap((item) => item.iva) }]

                this.isLoading = false
                // Top
                this.setTop(res.data.flatMap((item) => item.concepts))

                if (this.selectedYears.length > 0) {
                    this.sellSeriesYears = [this.selectedYears[0]]
                    this.getSellSeries(this.sellSeriesYears[0])
                }
            }
        },
        setTop(data) {
            const top = Object.values(
                data.reduce((acc, cvv) => {
                    const key = cvv.text
                    if (!acc[key]) {
                        acc[key] = {
                            ...cvv,
                            quantity: 0,
                        }
                    }
                    acc[key].quantity += cvv.quantity
                    return acc
                }, {})
            )
            this.topSellerOptions = {
                ...this.topSellerOptions,
                labels: top.map((item) => item.text),
            }
            this.topSellerSeries = top.map((item) => item.quantity)
            const totalQuantity = top.reduce((acc, item) => acc + item.quantity, 0)

            this.topSalesData = top
                .sort((a, b) => b.quantity - a.quantity)
                .map((item) => ({
                    product: item.text,
                    value: item.quantity,
                    percentage: ((item.quantity / totalQuantity) * 100).toFixed(2),
                    top: true,
                    // top: index <= 2,
                }))
            this.isLoadingTopSells = false
        },
        async getDataByYear(year) {
            return new Promise((resolve) => {
                const params = this.getParams(this.client, year)
                this.$gestios
                    .items('bills')
                    .list(params)
                    .then((res) => {
                        if (res.ok) {
                            resolve(res.data)
                        } else {
                            resolve([])
                        }
                    })
            })
        },
        async getSellSeries(year) {
            this.isLoadingSells = true
            if (!this.sellsSeries.length || !this.sellsSeries.find((item) => item.name === year)) {
                const dataYear = await this.getDataByYear(year)
                const data = dataYear.reduce((acc, cvv) => {
                    const month = new Date(cvv.date).getMonth()
                    if (!acc[month]) {
                        acc[month] = 0
                    }
                    acc[month] += cvv.subtotal
                    return acc
                }, [])
                this.sellsSeries.push({
                    name: year,
                    data,
                })
            }
            this.sellsSeries.sort((a, b) => a.name - b.name)
            this.isLoadingSells = false
        },
        handlerAddedPeriod(year) {
            this.getSellSeries(year)
        },
        handlerRemovedPeriod(year) {
            this.sellsSeries = this.sellsSeries.filter((item) => item.name !== year)
        },
    },
}
